import getConnections from "../../helpers/getConnections";
import useAccount from "../../settings/account/hooks/useAccount";
import { usePaymentApprovals } from "../../settings/paymentConnections/approvalsPayments/hooks/usePaymentApprovals";

export default function usePaymentsEnabled() {
    const { account, isLoading } = useAccount();
    const { approvals, isLoading: approvalsLoading } = usePaymentApprovals();

    // While the account is still resolving we can't tell whether payments are
    // enabled, so keep showing the dashboard (which renders its own loading
    // state) rather than briefly flashing — and getting stuck on — the Setup
    // screen.
    //
    // NOTE: a disabled (null-key) SWR reports `isLoading: false`. On a cold
    // page load the account/approvals keys are null until auth scopes are
    // ready, so `isLoading` alone is not enough to detect "still loading".
    // Treat a missing `account` as "not resolved yet" too — otherwise we fall
    // through to `return false` and render <Setup/> (which itself renders null
    // while its account loads) → blank dashboard until a remount.
    if (isLoading || approvalsLoading || !account) {
        return true;
    }

    const numEnabledConnections = getConnections(account, "enabled").length;
    const hasActiveApproval = approvals.some(
        (approval) => approval.case_status === "ACTIVE",
    );

    return (
        account.account_id?.endsWith("00000000") ||
        account.account_id?.endsWith("00000") ||
        numEnabledConnections > 0 ||
        hasActiveApproval
    );
}
